import 'reflect-metadata'
import { define, type, auto, Record, Collection, Store } from 'type-r'
import { openDB, deleteDB } from 'idb';

import PatientForm from './patient_form'
import FinancialPolicyForm from './financial_policy_form'
import { AuthorizationDisclosureForm } from './authorization_disclosure_form'
import CancellationPolicyForm from './cancellation_policy_form'

@define
export default class SiteStore extends Store {
    @auto csrf: string
    @(type(PatientForm).events({"change": "formchange"}).as) patientForm: PatientForm
    @(type(AuthorizationDisclosureForm).events({"change": "formchange"}).as) authorizationDisclosureForm: AuthorizationDisclosureForm
    @(type(CancellationPolicyForm).events({"change": "formchange"}).as) cancellationPolicyForm: CancellationPolicyForm
    @(type(FinancialPolicyForm).events({"change": "formchange"}).as) financialPolicyForm: FinancialPolicyForm
    db: any
    autosaveTimer: any;

    async dbinit() {
        // Initialize IndexedDB
        this.db = await openDB('backups', 1, {
            upgrade: function (db) {
                db.createObjectStore('backups', { keyPath: 'id' });
            }
        });
        await this.clearOldDbEntries();
        await this.maybeRestoreBackup('1');
    }
    async clearOldDbEntries() {
        try {
            // Create a transaction to read from the 'backups' object store
            // Retrieve the backup by ID
            const allRecords = await this.db.getAll('backups');
            let nowDt = new Date();
            for (var row of allRecords) {
                console.log(row);
                let dt = new Date(row.timestamp);
                let days = this.diffInDays(dt, nowDt);
                if (days > 7) {
                    console.log("Expire row", row);
                    await this.db.delete(row.id)
                }
            }

        } catch (err) {
            console.error(err)
        }
    }
    diffInDays(date1, date2) {
        const msPerDay = 1000 * 60 * 60 * 24;
        const diffMs = date2.getTime() - date1.getTime(); // Can be negative
        return Math.floor(diffMs / msPerDay); // Floor for whole days (e.g., 1.9 → 1)
    }
    // Assuming IndexedDB and Foxit PDF SDK are initialized
    async maybeRestoreBackup(id = 'currentDoc') {
        // Create a transaction to read from the 'backups' object store
        try {
            // Retrieve the backup by ID
            const backup = await this.db.get('backups', id);
            if (!backup || !backup.data) {
                console.log('No backup found for ID:', id);
                return false;
            }

            // Optional: Check timestamp or prompt user
            const backupTime = new Date(backup.timestamp);
            var msg = `Continue where you left off? (backup from ${backupTime.toLocaleString()})?`;

            if (confirm(msg)) {
                try {
                    // Load the ArrayBuffer into the Foxit PDFViewer
                    this.set(backup.data, {parse: true});
                    console.log('Data restored successfully from backup');
                    return true;
                } catch (error) {
                    console.error('Error loading data from backup:', error);
                    alert('Failed to restore data. The backup may be corrupted.');
                    return false;
                }
            }
            return false;
        }
        catch (err) {
            console.error('Error retrieving backup:', err);
            return false;
        }
    }
    async formchange() {
        this.queueAutosaveData();
    }
    queueAutosaveData() {
        if (this.autosaveTimer)
            clearTimeout(this.autosaveTimer);

        this.autosaveTimer = setTimeout(() => {
            this.autosaveData()
            this.autosaveTimer = null;
        }, 3000);
    }
    // Autosave function
    async autosaveData() {
        var totalBuffer = [];
        const data = this.toJSON();
        this.db.put('backups', { id: '1', data, timestamp: Date.now() });
        console.log("Total sz", JSON.stringify(data).length);
    }
    
    async removeBackups() {
        try {
            const id = '1';
            await this.db.delete('backups', id);
        } catch (error) {
            console.error('Transaction error:', error);
        }
    }
}

const store = window.sitestore = new SiteStore()
export { store };
